<template>
    <div class="container"  v-title="'申请入会'">
        <Navigation-bar id="navigation_bar" type="dark"></Navigation-bar>
        <div class="container_content">
            <div class="title">
                <h2>申请入会</h2>
                <p>CESA · 中国企业体育协会</p>
            </div>
            <div id="Membership">
                <div class="Membership_content">
                    <p>中国企业体育协会致力于推动企事业单位全民健身事业发展，增进企事业单位间的交流与合作，积极打造和弘扬企事业单位文化，为构建社会主义和谐社会服务。为加强协会组织建设，进一步扩大企事业单位体育影响力，欢迎企事业单位加入我会。如有意，请根据入会流程办理相关事宜。</p>
                    <div class="subtitle">加入「中企体协」</div>
                    <div class="function_item">
                        <div class="item_title">提交材料</div>
                        <ul>
                            <li>
                                <div class="item_subtitle">会员申请书</div>
                                <p>加盖单位公章的《会员申请书》2 份</p>
                                <YD-image src="rules/icon/icon_申请入会_会员申请书"></YD-image>
                            </li>
                            <li>
                                <div class="item_subtitle">单位营业执照/法人登记证（副本）</div>
                                <p>加盖单位公章的单位营业执照副本复印件或法人登记证副本复印件 1 份</p>
                                <YD-image src="rules/icon/icon_申请入会_单位"></YD-image>
                            </li>
                            <li>
                                <div class="item_subtitle">单位简介</div>
                                <p>加盖单位公章的单位简介 1 份</p>
                                <YD-image src="rules/icon/icon_申请入会_简介"></YD-image>
                            </li>
                            <li>
                                <div class="item_subtitle">法人身份证复印件</div>
                                <p>加盖单位公章的法人身份证复印件 1 份</p>
                                <YD-image src="rules/icon/icon_申请入会_法人"></YD-image>
                            </li>
                        </ul>
                        <button @click="download">
                            <span>《会员申请书》下载</span>
                            <YD-image src="rules/icon/icon-入口"></YD-image>
                        </button>
                    </div>
                    <p style="text-align: center;line-height:0.36rem;margin-bottom:0.64rem">纸质版文件邮寄至协会秘书处电子文件发送至协会邮箱</p>
                    <ul class="info">
                        <li>
                            <h4>协会地址</h4>
                            <p>北京市朝阳区曙光西里甲6号时间国际大厦A座3002</p>
                        </li>
                        <li>
                            <h4>邮编</h4>
                            <p>100027</p>
                        </li>
                        <li>
                            <h4>联系人</h4>
                            <p>白宝林</p>
                        </li>
                        <li>
                            <h4>邮箱</h4>
                            <p>baibaolin@cesa.org.cn</p>
                        </li>
                        <li>
                            <h4>电话/传真</h4>
                            <p>010-59762989</p>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import {
    saveFile
 } from "@js/appInteraction"
export default {
    name: 'Membership',
    data() {
        return {
            
        }
    },
    methods:{
        download(){
            saveFile(process.env.VUE_APP_PUBLIC_URL + '/files/中国企业体育协会会员申请书.docx','中国企业体育协会会员申请书.docx');
        }
    }
};
</script>
<style lang="scss" scoped>

.container_content{
    background: #1B1C1E;
    >.title{
        height: 198px;
        padding: 24px 40px 0;
        box-sizing: border-box;
        position: relative;
        h2{
            @include line-height(84px);
            font-size: 60px;
            color: #FFFFFF;
            font-weight: 500;
        }
        p{
            @include line-height(44px);
            font-size: 24px;
            color: #43C8D9;
            font-weight: 400;
            margin-top: 6px;
        }
    }
}
.Membership_content{
    width: 100%;
    height: auto;
    padding: 0 40px;
    box-sizing: border-box;
    p{
        font-size: 26px;
        color: #B7B7B7;
        line-height: 46px;
        font-weight: 400;
    }
    .subtitle{
        height: 40px;
        font-size: 32px;
        color: #FFFFFF;
        letter-spacing: 0.53px;
        line-height: 40px;
        font-weight: 600;
        margin-top: 64px;
        margin-bottom: 48px;
    }
    .function_item{
        width: 100%;
        height: auto;
        background: #FFFFFF;
        border-radius: 66px;
        position: relative;
        padding-top: 6px;
        box-sizing: border-box;
        margin-bottom: 40px;
        .item_title{
            width: auto;
            @include line-height(100px);
            display: inline-flex;
            background: #1B1C1E;
            border-radius: 57.2px;
            padding: 0 40px;
            font-size: 32px;
            color: #FFFFFF;
            letter-spacing: 0.53px;
            font-weight: 600;
            margin-left: 10px;
        }
        ul{
            margin-top: 50px;
            li{
                width: 100%;
                height: auto;
                padding-left: 110px;
                padding-top: 8px;
                box-sizing: border-box;
                margin-bottom: 32px;
                position: relative;
                .item_subtitle{
                    font-size: 32px;
                    color: #1B1C1E;
                    line-height: 40px;
                    font-weight: 500;
                    margin-bottom: 16px;
                }
                p{
                    font-size: 26px;
                    color: #4D5561;
                    line-height: 44px;
                    font-weight: 400;
                    padding-right: 76px;
                    box-sizing: border-box;
                }
                img{
                    width: 56px;
                    height: 56px;
                    position: absolute;
                    top: 0;
                    left: 46px;
                }
            }
        }
        button{
            width: 100%;
            height: 105px;
            font-size: 32px;
            color: #1B1C1E;
            letter-spacing: 0.53px;
            font-weight: 600;
            display: flex;
            align-items: center;
            justify-content: center;
            border-top: 1px #F0F0F0 solid;
            margin-top: 48px;
            img{
                width: 32px;
                height: 32px;
                margin: 0 10px;
            }
        }
    }
    .info{
        width: calc(100% + 40px);
        height: auto;
        margin-bottom: 64px;
        li{
            width: 100%;
            border-bottom: 1px #606060 solid;
            margin-bottom: 19px;
            &:last-of-type{
                border: none;
                margin: 0;
            }
            h4{
                font-size: 28px;
                color: #CACACA;
                font-weight: 400;
                line-height: 40px;
                margin-bottom: 16px;
            }
            p{
                font-size: 32px;
                color: #FFFFFF;
                font-weight: 500;
                line-height: 44px;
                margin-bottom: 20px;
            }
        }
    }
}
</style>